import { SetupContext, computed, ref } from "@vue/composition-api";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { findGetters as findDrinkGetters } from "@dcc/store/drinking/getters";
import { findGetters as findScoreGetters } from "@dcc/store/score/getters";
import { getActions } from "@dcc/store/drinking/actions";
import { RiskLevel } from "@dcc/types/riskLevel";

export const useSlider = (context: SetupContext) => {
  const { getWeeklyDrinkingDays, getDrinkFrequency } = findDrinkGetters(
    context.root.$store
  );

  const drinkFrequency = getDrinkFrequency().value;
  const weeklyDrinkingDays = getWeeklyDrinkingDays().value;

  const { getRiskLevel, getPercentWhoDrinkLess } = findScoreGetters(
    context.root.$store
  );
  const riskLevel = getRiskLevel().value;
  const initialPercentage = getPercentWhoDrinkLess().value;

  const { updateTargetPercentage, clearTargetPercentage } = getActions(
    context.root.$store
  );

  const showSlider =
    drinkFrequency === DrinkFrequency.Weekly &&
    riskLevel >= RiskLevel.Increasing &&
    weeklyDrinkingDays.length < 4;

  let sliderValue = ref(initialPercentage);
  const sliderPercentage = computed({
    get: () => {
      return sliderValue.value;
    },
    set: (val) => {
      sliderValue.value = val;
      if (val === initialPercentage) {
        clearTargetPercentage();
      } else {
        updateTargetPercentage(val);
      }
    }
  });

  return {
    showSlider,
    sliderPercentage,
    initialPercentage
  };
};
